var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudentimg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 237,
    height: 307,
    viewBox: "0 0 237 307",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_615",
    "data-name": "Rectangle 615",
    width: 237,
    height: 307,
    transform: "translate(7500.366 1032)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M0-1440H537.26v302.209H0Z",
    transform: "translate(0 1439.996)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M1085.817-944.116h25.813v21.546h-25.813Z",
    transform: "translate(-1085.817 944.116)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path60",
    d: "M1248.852-829.423h47.281v109.587h-47.281Z",
    transform: "translate(-1248.852 829.423)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path76",
    d: "M1295.482-474.784h30.779v12.88h-30.779Z",
    transform: "translate(-1295.482 474.784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path92",
    d: "M1287.482-590.784h19.027v6.436h-19.027Z",
    transform: "translate(-1287.482 590.784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path108",
    d: "M1390.143-573.451H1400.5v8.674h-10.353Z",
    transform: "translate(-1390.143 573.451)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path124",
    d: "M1262.149-602.784h15.109v4.477h-15.109Z",
    transform: "translate(-1262.149 602.784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path140",
    d: "M1363.477-616.117h14.271v3.918h-14.271Z",
    transform: "translate(-1363.477 616.117)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path156",
    d: "M1270.149-633.45h28.261v4.2h-28.261Z",
    transform: "translate(-1270.149 633.45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path172",
    d: "M1342.143-637.45h14.271v1.679h-14.271Z",
    transform: "translate(-1342.143 637.45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path188",
    d: "M1402.143-654.784h8.395v3.078h-8.395Z",
    transform: "translate(-1402.143 654.784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path204",
    d: "M1354.143-670.784h16.23v2.518h-16.23Z",
    transform: "translate(-1354.143 670.784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path220",
    d: "M1266.149-714.784h5.876v9.234h-5.876Z",
    transform: "translate(-1266.149 714.784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path236",
    d: "M1258.149-725.45h1.4V-715.1h-1.4Z",
    transform: "translate(-1258.149 725.45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path252",
    d: "M1252.816-730.783h2.239v12.032h-2.239Z",
    transform: "translate(-1252.816 730.783)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path272",
    d: "M1130.149-841.45h8.964v17.629h-8.964Z",
    transform: "translate(-1130.149 841.45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path288",
    d: "M1039.483-794.783h8.675v19.308h-8.675Z",
    transform: "translate(-1039.483 794.783)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path304",
    d: "M1055.483-573.451h6.716v24.625h-6.716Z",
    transform: "translate(-1055.483 573.451)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path320",
    d: "M1064.816-456.118h3.078v13.152h-3.078Z",
    transform: "translate(-1064.816 456.118)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path336",
    d: "M1132.816-770.783h17.629v17.629h-17.629Z",
    transform: "translate(-1132.816 770.783)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path364",
    d: "M1523.476-532.117h15.39v59.323h-15.39Z",
    transform: "translate(-1523.476 532.117)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path380",
    d: "M1472.81-546.784h5.317v20.147h-5.317Z",
    transform: "translate(-1472.81 546.784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path396",
    d: "M1472.81-370.784h9.234v25.464h-9.234Z",
    transform: "translate(-1472.81 370.784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path412",
    d: "M1614.143-498.784h14.271v24.624h-14.271Z",
    transform: "translate(-1614.143 498.784)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(-7500.366 -1032)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "translate(7350.053 1015.937)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g20",
    transform: "translate(227.878 93.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M-109.293-5.8a1.667,1.667,0,0,1-1.57-.65l-.247-.329-.56-.56v6.7a8.5,8.5,0,0,1-1.119,4.215l-1.992,2.241a4.042,4.042,0,0,1-.54.505l-1.574,1.224a5.648,5.648,0,0,1-1.421.806l-2.237.87a6.9,6.9,0,0,0-3.239,2.6,4.445,4.445,0,0,1-1.167,1.188l-2.136,1.479a6.411,6.411,0,0,1-1.738.849l-1.765.552a7.477,7.477,0,0,1-3.609.212l-.963-.18a9.537,9.537,0,0,1-3.152-1.2l.909,2.281.82,3.006c.013.048.027.1.043.143l.816,2.448.08.4a6.294,6.294,0,0,0,.706,1.885l.613,1.073.56,1.4.28,1.119,4.038-3.088a16.091,16.091,0,0,1,1.495-1.015l4.821-2.892,5.317-3.638,3.918-2.8,3.358-2.239,1.679-1.4-.521-2.78a18.584,18.584,0,0,1-.318-3.423V-2.284a10.926,10.926,0,0,1,.132-1.7Z",
    transform: "translate(138.322 7.335)",
    fill: "#eab5a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g24",
    transform: "translate(227.878 104.069)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g36",
    opacity: 0.4,
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g34",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "M-88.632-10.545a4.038,4.038,0,0,1-.539.505l-1.574,1.224a5.651,5.651,0,0,1-1.42.806l-2.237.87a6.9,6.9,0,0,0-3.239,2.6,4.445,4.445,0,0,1-1.167,1.188l-2.136,1.479a6.417,6.417,0,0,1-1.738.849l-1.765.552a7.476,7.476,0,0,1-3.609.212l-.963-.18a9.542,9.542,0,0,1-3.152-1.2l.909,1.441,1.4,5.317,1.4,3.078.273-6.285a.707.707,0,0,1,.074-.286.767.767,0,0,1,.687-.424h.116a3.423,3.423,0,0,1,1.531.362l.724.362a2.787,2.787,0,0,0,.48.187l.618.177a3.2,3.2,0,0,0,2.136-.135L-98.952.926l2.8-1.679L-91.4-4.391l1.679-3.078,1.959-2.239,1.4-3.638Z",
    transform: "translate(112.173 13.345)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g40",
    transform: "translate(212.21 60.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "M-5.558-21.033-4.088-22.5A7.123,7.123,0,0,1-.973-24.325l4.6-1.289a7.254,7.254,0,0,1,1.21-.23l6.778-.7a14.137,14.137,0,0,1,1.448-.074h4.081a12.742,12.742,0,0,1,2.668.282,7.453,7.453,0,0,1,4.259,2.632,2.987,2.987,0,0,1,.647,1.646l.379,5.115a26.661,26.661,0,0,0,.4,3.011l.625,3.281a1.024,1.024,0,0,0,1.287.793l1.91-.546a.98.98,0,0,1,1.207.66l.294.98a1.7,1.7,0,0,1-.339,1.6l-.471.55A.721.721,0,0,0,30.237-5.5l.518.259a.868.868,0,0,1,.442.526L32.768.523,33.888,5l.839.839.28-1.4L35.846.523l.839-3.358.432-1.439a2.734,2.734,0,0,1,1.754-1.808l.333-.111h1.02a.915.915,0,0,1,.647.268l.292.292.608,1.418A2.861,2.861,0,0,1,42-3.087V-.542a2.733,2.733,0,0,1-.037.448l-.5,3.022a1.99,1.99,0,0,1-.051.225l-.949,3.321a1.64,1.64,0,0,1-.527.809l-.721.6a2.614,2.614,0,0,1-1.3.58l-.247.035a1.668,1.668,0,0,1-1.57-.65l-.247-.329-.56-.56v6.7a8.5,8.5,0,0,1-1.119,4.215l-1.992,2.241a4.041,4.041,0,0,1-.539.505l-1.574,1.224a5.651,5.651,0,0,1-1.42.806l-2.237.87a6.9,6.9,0,0,0-3.239,2.6A4.436,4.436,0,0,1,22,27.309l-2.136,1.479a6.405,6.405,0,0,1-1.738.849l-1.765.552a7.48,7.48,0,0,1-3.609.212l-.963-.18a9.548,9.548,0,0,1-3.152-1.2,11.323,11.323,0,0,1-2.4-1.923L2.268,22.909.062,20.364a11.976,11.976,0,0,1-2.188-3.7l-.817-2.216A20.636,20.636,0,0,1-3.6,12.311L-4.656,8.084a3.408,3.408,0,0,0-.191-.555,12.92,12.92,0,0,1-1.1-4.709l-.177-4.256-.56-7.555-.28-7.555-.042-.422a5.04,5.04,0,0,1,1.451-4.065",
    transform: "translate(7.034 26.62)",
    fill: "#eab5a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g44",
    transform: "translate(195.008 215.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M-274.668,0l-17.1,14.615A4.264,4.264,0,0,1-292.3,15l-18.524,11.441a3.177,3.177,0,0,1-.464.237l-3.7,1.524a2.174,2.174,0,0,1-1.634.008l-1.817-.727a1.041,1.041,0,0,1-.295-.18l-3.94-3.415a1.9,1.9,0,0,0-.266-.193l-1.258-.754h-1.5a1.72,1.72,0,0,0-.855.227l-1.561.892h-.863a2.446,2.446,0,0,0-1.468.489l-.467.35-.84.56-1.192-.17a.888.888,0,0,0-.98.635l-.223.779a1.073,1.073,0,0,0,.1.827l.574,1a1.589,1.589,0,0,0,.945.741l1.009.288a2.417,2.417,0,0,0,.666.093h1.619l-2.239,1.119-5.876,2.518-3.638,1.679-5.071,2.282a2.005,2.005,0,0,0-.845.716l-.332.5a2.316,2.316,0,0,0-.374,1.54l.1.874a1.958,1.958,0,0,0,.723,1.313l.024.019a2.07,2.07,0,0,0,1.675.418l3.544-.664,3.078-.839.28.56-3.078,1.4a2.307,2.307,0,0,0-.644,2.011l.135.813a2.124,2.124,0,0,0,1.58,1.711l.888.222,2.518-.839h.839l-.839,1.4-.053.161a3.4,3.4,0,0,0,.342,2.875l.121.193a1.465,1.465,0,0,0,1.242.688h1.707l1.679-1.119h.84l-.28.839-.468.468a1.4,1.4,0,0,0-.309,1.506,1.414,1.414,0,0,0,.756.775l.747.32a2.271,2.271,0,0,0,1.388.13l1.8-.4,7.835-3.638,3.918-1.679,3.638-3.078,2.287-1.83a4.112,4.112,0,0,1,1.124-.639l.656-.246a15.27,15.27,0,0,0,1.882-.855l2.725-1.467,8.395-3.638,11.473-4.2,9.8-3.609a16.158,16.158,0,0,0,1.635-.707l8.648-4.324a13.578,13.578,0,0,0,1.219-.69L-257.1,21.1a9.586,9.586,0,0,1,1.287-.687l5.926-2.607a6.761,6.761,0,0,1,.819-.3l3.461-1.018a1.833,1.833,0,0,0,1.2-1.115,5.924,5.924,0,0,0,.327-2.846l-.076-.585a45.922,45.922,0,0,0-1.971-8.585l-5.037,1.959-5.6.839-5.876-1.119-5.6-1.4-3.918-1.4Z",
    transform: "translate(347.623)",
    fill: "#eab5a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g48",
    transform: "translate(207.241 43.088)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "M-186.471-196.929l-.272,2.954v5.349l-.008,1.783,1.465-5.381a10.479,10.479,0,0,0,.3-1.6l.1-.863a2.112,2.112,0,0,1,.747-1.389,2.851,2.851,0,0,0,1.026-2.19v-1.183l1.119-3.638.28-4.757.25-.563a6.73,6.73,0,0,0,.449-4.054l-.14-.7-1.4-7.275-1.4-5.6-2.041-6.122a5.7,5.7,0,0,0-.52-1.13l-1.9-3.166a2.834,2.834,0,0,0-.763-.834l-1.89-1.374a3.909,3.909,0,0,0-1.6-.684l-1.1-.2a2.34,2.34,0,0,1-1.636-1.182l-.652-1.2a2.914,2.914,0,0,0-1.438-1.3l-2.141-.892a2.348,2.348,0,0,1-.505-.289l-1.036-.777a4.608,4.608,0,0,0-2.168-.883l-4.069-.531a8.328,8.328,0,0,1-2.245-.621l-3.414-1.484a6.567,6.567,0,0,0-4.013-.395l-3.089.672a11.684,11.684,0,0,0-2.46.83l-2.241,1.046a9.545,9.545,0,0,0-1.469.852l-3.18,2.245a10.463,10.463,0,0,0-1.615,1.409l-.769.824a16.236,16.236,0,0,0-3.533,5.943v0a7.826,7.826,0,0,0-.56,2.906v1.184a2.956,2.956,0,0,0,.55,1.718l.486.68a2.4,2.4,0,0,1,.432,1.128l.148,1.334a3.157,3.157,0,0,1-.075,1.114l-.4,1.606q-.021.082-.034.165l-.212,1.27a4.007,4.007,0,0,0-.054.657v2.467l-.24,3.118a2.587,2.587,0,0,0,.125,1.015l1.514,4.542,1.679,3.918.56,1.4.56,2.518L-229-198.4l-1.125-3.566.053-3.834-.5-6.93-.357-8.573-.1-1.268a5.642,5.642,0,0,1,2.014-4.761l1.124-.937,1.959-1.4,5.251-1.387,4.787-.75,6.608-.393,4.34.012,2.3.461a4.1,4.1,0,0,1,3.293,4.017l.806,8,.671,3.526a.99.99,0,0,0,1.244.767l.989-.281,1.066-.306a.843.843,0,0,1,1.047.589l.366,1.342a1.438,1.438,0,0,1-.489,1.5l-.11.088a.953.953,0,0,0-.29,1.1l.2.491a.288.288,0,0,0,.358.166.573.573,0,0,1,.736.4l.388,1.491,2.257,8.268.839.839,1.244-5.859.994-3.935.488-1.039.631-.64.941-.5,1.3-.057.56.28.322.322.518,1.357.28.56v3.638l-.4,2.036-.444,1.882-.449,1.807-.39,1.271-.95.818-1.009.581Z",
    transform: "translate(235.999 249.236)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g52",
    transform: "translate(213.957 110.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "M-180.15,0-187.7,4.2l-14.271,9.514-7.275,5.037-1.119-2.239-9.234,7.555-7,5.876-1.4,2.518,2.239,5.037,1.119,2.239.56,1.679.56.56s-.56,3.358-.56,3.638.839,3.078.839,3.078L-221,53.446l1.119,4.477v9.234l1.959,4.2-.28,6.436-1.959,8.675-.56,9.234,1.679,8.675,1.4,4.2-.839,7.275-.56,7.835.28,8.395-.56,31.9-1.4,10.074,2.518,3.078,2.239-1.119.56,4.477,8.954-.839,4.2-.28h8.115l6.716-.56,6.156-1.679,12.872-7.835,15.67-11.193,2.239-34.7,2.239-.56,3.638,2.8,2.518,1.4,5.037-5.6,4.477-5.876v-3.918l-2.239-2.8-3.918-3.358-.839-1.119,1.4-4.477-.56-7,.56-1.959L-139.3,88.7l-.56-3.078-.56-2.518,1.119-5.037-1.119-3.358,1.119-1.959-.839-3.358-1.119-2.239.28-3.078-.28-1.4-2.239-1.4,1.679-.28.56-1.679-1.119-1.119,2.518-1.959,1.679-3.078-6.716-3.918.839-5.037-1.4-3.638-1.679-7.275-1.959-3.078-2.518-5.317-8.115-9.234-2.518-2.8-5.037-1.959-2.8.839-3.638-1.4Z",
    transform: "translate(227.999)",
    fill: "#0073d2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g56",
    transform: "translate(262.094 128.14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g68",
    opacity: 0.3,
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g66",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "M-106.514-28.716l2.472,5.218a.344.344,0,0,0,.023.041l1.911,3a.373.373,0,0,1,.049.117l1.659,7.187a.35.35,0,0,0,.015.051l.6,1.564a8.051,8.051,0,0,1,.427,4.214L-99.792-4.7a.376.376,0,0,0,.182.386l6.176,3.6a.376.376,0,0,1,.14.5L-94.76,2.478a.38.38,0,0,1-.1.117L-96.98,4.244a.376.376,0,0,0-.035.563l.654.654a.375.375,0,0,1,.091.385l-.414,1.244a.376.376,0,0,1-.3.252l-.476.079a.376.376,0,0,0-.137.69l1.259.787a.376.376,0,0,1,.169.245l.237,1.186a.389.389,0,0,1,.006.108l-.266,2.917a.376.376,0,0,0,.038.2l1.053,2.106a.366.366,0,0,1,.028.077l.793,3.172a.377.377,0,0,1-.038.278l-.961,1.682a.376.376,0,0,0-.03.305l1.033,3.1a.376.376,0,0,1,.01.2l-1.078,4.854a.373.373,0,0,0,0,.163l.541,2.437.55,3.025a.381.381,0,0,0,.034.1l1.03,2.06a.378.378,0,0,1,.025.271l-.5,1.753a.378.378,0,0,0-.013.133l.548,6.855a.376.376,0,0,1-.016.142l-1.32,4.224a.375.375,0,0,0,.058.338l.7.932a.367.367,0,0,0,.056.06l3.859,3.308a.333.333,0,0,1,.049.05l2.134,2.668a.376.376,0,0,1,.083.235v3.659a.376.376,0,0,1-.077.228l-4.391,5.763-.02.024-4.826,5.362a.376.376,0,0,1-.462.077l-2.232-1.24a.4.4,0,0,1-.047-.031l-3.055-2.35a.376.376,0,0,1,.111-.655l3.379-1.127a.375.375,0,0,0,.217-.188l1-2a.374.374,0,0,0,.038-.21l-.543-4.887a.363.363,0,0,0-.017-.077l-1.823-5.471a.376.376,0,0,0-.487-.234l-5.138,1.887a.38.38,0,0,1-.074.019l-4.99.749a.377.377,0,0,1-.133,0l-8.636-1.813-.035-.009-6.576-2.058a.374.374,0,0,1-.138-.078l-2.332-2.073a.376.376,0,0,1-.126-.281V49.992a.376.376,0,0,1,.11-.266l1.179-1.179a.376.376,0,0,0,.11-.266v-.511a.376.376,0,0,0-.132-.286l-1.8-1.543a.366.366,0,0,0-.058-.041l-1.773-1.013a.376.376,0,0,1-.184-.264l-.241-1.446a.369.369,0,0,1,0-.115l.253-1.769a.377.377,0,0,0-.05-.247l-1.579-2.631a.386.386,0,0,1-.045-.112l-.529-2.382a.382.382,0,0,1,0-.155l.211-1.055a.375.375,0,0,1,.322-.3l1.852-.232a.376.376,0,0,1,.222.041l4.57,2.419a.374.374,0,0,0,.176.044h.09a.376.376,0,0,0,.376-.376v-1.8a.371.371,0,0,0-.019-.119l-1.92-5.76a.384.384,0,0,1-.019-.119V24.5a.376.376,0,0,1,.075-.226l1.558-2.078a.379.379,0,0,0,.064-.134l.507-2.03a.375.375,0,0,0-.029-.259.376.376,0,0,0-.584-.115l-1.682,1.472a.377.377,0,0,1-.416.053l-1.374-.687a.377.377,0,0,1-.133-.111l-1.619-2.159-.012-.017-.462-.692a.376.376,0,0,1-.052-.3l.493-1.971a.375.375,0,0,0-.008-.21l-.48-1.44a.375.375,0,0,1,.011-.267l.74-1.726a.376.376,0,0,0,.025-.21l-.252-1.515a.373.373,0,0,1,0-.112l.544-4.079a.373.373,0,0,0,0-.123l-.518-2.59a.376.376,0,0,1,.05-.273l1.218-1.948a.377.377,0,0,0,.029-.343l-1.885-4.578-1.374-3.3a.373.373,0,0,1-.029-.123l-.555-9.716c0-.009,0-.018,0-.027l-.827-6.339a.382.382,0,0,1,.015-.163l1.465-4.605a6.721,6.721,0,0,1,1.531-2.59l4.162-4.381a.375.375,0,0,1,.224-.114l6.237-.813a.373.373,0,0,1,.133.006l3.949.911a14.53,14.53,0,0,1,5.863,2.855l4.606,3.72a.374.374,0,0,1,.1.132",
    transform: "translate(134.805 36.343)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g72",
    transform: "translate(271.88 202.567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g86",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g84",
    opacity: 0.4,
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g82",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path80",
    d: "M-115.886-42.14h0a10.043,10.043,0,0,1-8.948,1.1l-7-2.5-9.794-5.876-5.037-3.918,7.555,4.2,8.286,4.674a20,20,0,0,0,5.575,2.123l3.489.758Z",
    transform: "translate(146.666 53.333)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g88",
    transform: "translate(270.201 178.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g100",
    opacity: 0.4,
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g98",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path96",
    d: "M0-24.231l4.2-3.078,7.835-2.239,7-1.119L9.514-28.148Z",
    transform: "translate(0 30.667)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g104",
    transform: "translate(291.746 181.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g116",
    opacity: 0.4,
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g114",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path112",
    d: "M0,0,7.275,1.119l3.078,4.2-.56,3.358L6.716,3.918Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g120",
    transform: "translate(264.884 175.704)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g132",
    opacity: 0.4,
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g130",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path128",
    d: "M-7.375,0-9.333,2.239l1.4,2.239,5.6-1.119L5.777,0Z",
    transform: "translate(9.333)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g136",
    transform: "translate(286.15 172.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g148",
    opacity: 0.4,
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g146",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path144",
    d: "M-47.408,0-60,3.358l6.436.56h6.716l1.119-2.239Z",
    transform: "translate(60)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g152",
    transform: "translate(266.563 169.268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g164",
    opacity: 0.4,
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g162",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path160",
    d: "M0,0,7,.56,11.473,2.8l7.275-.28,9.514-.28-7.835,1.4L8.115,4.2l-5.876-.56Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g168",
    transform: "translate(281.673 168.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g180",
    opacity: 0.4,
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g178",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path176",
    d: "M0,0,1.959,1.679,14.271,1.4Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g184",
    transform: "translate(294.265 164.791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g196",
    opacity: 0.4,
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g194",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path192",
    d: "M-31.605,0l-5.6,1.4L-40,3.078h4.2l3.078-1.119Z",
    transform: "translate(40)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g200",
    transform: "translate(284.191 161.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g212",
    opacity: 0.4,
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g210",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path208",
    d: "M-53.729,0l1.959,1.679-5.6.839L-68,.839Z",
    transform: "translate(68)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g216",
    transform: "translate(265.724 152.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g228",
    opacity: 0.4,
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g226",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path224",
    d: "M-22.124,0l-4.2,3.918L-28,9.234-25.482,4.2Z",
    transform: "translate(28)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g232",
    transform: "translate(264.045 149.96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g244",
    opacity: 0.4,
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g242",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path240",
    d: "M-3.161,0-4,5.6l1.4,4.757L-3.44,5.876Z",
    transform: "translate(4)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g248",
    transform: "translate(262.926 148.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g260",
    opacity: 0.4,
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g258",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path256",
    d: "M-2.107,0l-.56,5.6,2.239,6.436L-2.107,5.6Z",
    transform: "translate(2.667)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g264",
    transform: "translate(299.023 217.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path266",
    d: "M-15.8,0l-1.119,8.675L-20,18.188l8.115-9.234Z",
    transform: "translate(20)",
    fill: "#1b1464"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g268",
    transform: "translate(237.182 125.616)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g280",
    opacity: 0.4,
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g278",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path276",
    d: "M-8.428,0-5.35,9.794s3.358,7.835,3.638,7.835-5.876-3.358-5.876-3.358l-3.078-7.835Z",
    transform: "translate(10.667)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g284",
    transform: "translate(218.154 135.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g296",
    opacity: 0.4,
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g294",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path292",
    d: "M-13.7,0l-3.638,11.193.839,5.6,7.835,2.518L-10.9,14.551Z",
    transform: "translate(17.333)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g300",
    transform: "translate(221.512 181.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g312",
    opacity: 0.4,
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g310",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path308",
    d: "M-11.589-12.642-14.667,5.826v2.8l3.078-6.436L-7.951-9.564-10.469-16Z",
    transform: "translate(14.667 16)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g316",
    transform: "translate(223.471 206.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g328",
    opacity: 0.4,
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g326",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path324",
    d: "M-8.428,0l-2.239,7.835,1.4,5.317L-7.589,5.6Z",
    transform: "translate(10.667)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g332",
    transform: "translate(237.742 140.446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g344",
    opacity: 0.4,
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g342",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path340",
    d: "M-66.371,0l-8.954,7L-84,17.629V16.306a8.655,8.655,0,0,1,3.752-7.132l.725-.5,5.6-4.757Z",
    transform: "translate(84)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g348",
    transform: "translate(262.366 170.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path350",
    d: "M-32.659-273.912l-8.675,12.592,4.757,12.032,7.835,17.629,1.959,3.918,16.51,12.032,25.184-10.074,5.317-1.679s6.716-5.317,6.716-5.6,11.193-17.069,11.193-17.069l9.794-18.189,1.119-5.6,2.239-3.078-1.119-1.679,4.757-7.555v-7l.839-1.959-1.959-4.477-5.6-1.679-5.876-17.909L36.458-326.8v-.839L31.7-332.675,18.549-346.666l-3.918,1.679-2.518,1.959-3.078-.839-3.918,6.436-1.4,8.675,2.239,12.592,1.4,8.674L2.039-299.1l2.518,5.317L3.438-290.7-1.6-284.825l-3.358,4.2-.839.28-3.078-1.959-7,2.239-7.275,3.918-5.317,2.518Z",
    transform: "translate(41.333 346.666)",
    fill: "#1b1464"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g352",
    transform: "translate(299.862 217.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path354",
    d: "M0-259.163l9.234-10.074,8.115-10.353,7.835-9.514L31.9-301.416l2.8-7.555,2.518-7.555,3.638-6.156,8.954-4.757,5.6-.56,2.595.527,1.6,1.152,1.184,3.148-.345,2.449h-.28l-.28-3.638-2.239-.56-3.918.839-3.078,1.4-3.638,4.477-3.078,4.757-1.679,3.638-3.638,5.876,4.477-.839,4.2-.839,4.477-.28,3.358.28.71.086.689,1.033-1.679,2.8-1.679-.84-5.6.28-3.078.839L38.616-298.9l-3.358,1.119L30.5-289.1,24.9-279.03v1.119l-6.436,5.6-5.876,6.156-6.156,4.477-4.477,2.518Z",
    transform: "translate(0 327.999)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g356",
    transform: "translate(286.151 229.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path358",
    d: "M0-214.915l1.4,1.679H4.477l5.317-8.395L14.271-231.7l1.959-6.716,1.4-7.275,3.358-9.514,1.959-7-1.119-7.555L20.987-272l-1.679.839.56,1.679-1.679,8.115-1.959,8.954L12.312-239.54,7.835-226.668l-4.2,8.395-1.959,2.518Z",
    transform: "translate(0 271.999)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g360",
    transform: "translate(319.729 190.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g372",
    opacity: 0.2,
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g370",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path368",
    d: "M-3.161-45.3,6.633-57.333,2.716-35.787-.362-24.874l7-11.753L1.876-22.915l5.317,1.4,4.2,8.115-5.6,1.119-1.679-7L-.362-22.355,4.115-15.08l1.4,8.115L-.362,1.989-4-6.126-.362-14.8l-1.679-9.234Z",
    transform: "translate(4 57.333)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g376",
    transform: "translate(309.095 187.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g388",
    opacity: 0.4,
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g386",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path384",
    d: "M0,0,5.317,5.6,4.757,16.23l-1.4,3.918Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g392",
    transform: "translate(309.095 224.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g406",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g404",
    opacity: 0.2,
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g402",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path400",
    d: "M0-42.14l.28,6.156,5.037-5.037v5.037L4.2-33.186,7-27.869v-5.6c0-.56,2.239-3.358,2.239-3.358v-16.51l-2.518,7Z",
    transform: "translate(0 53.333)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g408",
    transform: "translate(338.757 197.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g420",
    opacity: 0.4,
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g418",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path416",
    d: "M0-7.375s3.358,1.4,3.358.839,3.918-2.8,3.918-2.8L10.353.74l3.918,9.794L5.6,13.332,2.518,15.291,3.638,5.777,1.4-4.3Z",
    transform: "translate(0 9.333)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g424",
    transform: "translate(254.531 124.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path426",
    d: "M-117.257-28.985l4.579,3.7a.52.52,0,0,1,.145.184l2.453,5.179a.519.519,0,0,0,.032.057l1.893,2.975a.524.524,0,0,1,.069.164l1.65,7.152a.556.556,0,0,0,.022.071l.583,1.517A8.2,8.2,0,0,1-105.4-3.7l-.413,2.474a.525.525,0,0,0,.253.539l5.963,3.478a.524.524,0,0,1,.2.7l-1.382,2.535a.524.524,0,0,1-.139.163l-1.963,1.527a.525.525,0,0,0-.049.785l.47.47a.524.524,0,0,1,.127.537l-.357,1.072a.524.524,0,0,1-.412.351.525.525,0,0,0-.192.963l.871.545a.525.525,0,0,1,.236.342l.221,1.1a.531.531,0,0,1,.008.15l-.259,2.854a.522.522,0,0,0,.053.282l1.026,2.054a.513.513,0,0,1,.04.107l.774,3.1a.525.525,0,0,1-.053.388l-.9,1.572a.526.526,0,0,0-.042.426l1,3a.523.523,0,0,1,.015.28l-1.062,4.781a.529.529,0,0,0,0,.228l.534,2.4.546,3a.53.53,0,0,0,.047.141l.995,1.989a.526.526,0,0,1,.035.379l-.477,1.671a.52.52,0,0,0-.018.186l.544,6.8a.528.528,0,0,1-.022.2L-100.473,54a.526.526,0,0,0,.081.471l.644.858a.529.529,0,0,0,.078.084l3.836,3.288a.546.546,0,0,1,.068.071l1.709,2.136a.149.149,0,0,0,.261-.128l-1.149-4.793a.151.151,0,0,1,.011-.1L-93,52.032a.2.2,0,0,0,.01-.025l1.388-4.718a.149.149,0,0,0,.005-.054l-.276-3.318a.169.169,0,0,0,0-.024L-93,39.437a.145.145,0,0,1,0-.02l-.838-7.541s0-.005,0-.008l-1.114-6.684a.146.146,0,0,1,0-.055l1.109-5.268a.138.138,0,0,1,.014-.039l2.225-4.171.009-.015,1.89-2.7a.149.149,0,0,1,.169-.056l2.347.782a.149.149,0,0,0,.126-.015l2.168-1.355.024-.012,2.782-1.113.008,0,1.991-.664a.149.149,0,0,0-.017-.287l-6.176-1.286-5.536-1.384a.149.149,0,0,1-.092-.069L-94.671,2.78a.11.11,0,0,1-.009-.018L-96.058-.545a.151.151,0,0,1-.009-.086l.536-2.682a.148.148,0,0,0-.034-.127l-3.828-4.375a.148.148,0,0,0-.1-.051l-5.155-.271a.149.149,0,0,1-.133-.1l-1.646-4.663-1.394-4.46a.151.151,0,0,0-.015-.032l-1.666-2.777-.007-.013-2.507-5.291a.141.141,0,0,0-.022-.034l-3.893-4.449a.151.151,0,0,0-.025-.023L-122.929-35a.107.107,0,0,0-.02-.012l-3.315-1.658a.15.15,0,0,0-.067-.016h-5.526a.147.147,0,0,0-.066.016l-2.206,1.1a11.8,11.8,0,0,0-3.832,3.053l-2.319,2.816-.012.016-3.626,5.858a.151.151,0,0,0-.01.02L-147-16.545l-.006.017-1.112,3.893a.157.157,0,0,0-.006.032l-.278,4.736s0,.006,0,.009v3.615a.144.144,0,0,0,0,.036l1.115,4.46,1.4,5.037,1.395,5.579a.156.156,0,0,1,0,.036v2.141a.149.149,0,0,0,.066.124l1.542,1.028a.148.148,0,0,1,.066.133l-.274,4.658a.167.167,0,0,0,0,.026l.553,4.7a.147.147,0,0,0,.032.077l2.464,3.011a.15.15,0,0,1,.032.076l.832,6.659a.127.127,0,0,1,0,.029l-.268,3.743a.149.149,0,0,0,.149.16h2.593a.149.149,0,0,1,.083.025l3.283,2.188a.148.148,0,0,0,.083.025h.646a.149.149,0,0,0,.149-.149v-1.5a.153.153,0,0,0-.009-.05l-1.385-3.877a.146.146,0,0,1-.008-.034l-.558-5.3-.552-3.59a.148.148,0,0,0-.042-.083l-3.556-3.556a.149.149,0,0,1-.043-.114l.276-4.41.279-3.623a.146.146,0,0,1,.005-.03l.544-1.9a.151.151,0,0,0,0-.083l-1.944-6.666a.125.125,0,0,1,0-.017l-.838-5.028-1.118-6.431a.1.1,0,0,1,0-.01l-.838-8.1a.141.141,0,0,1,0-.015v-4.46a.139.139,0,0,1,0-.018l.555-4.439a.146.146,0,0,1,.018-.055l2.216-3.878a.159.159,0,0,1,.018-.025l2.225-2.5.006-.006,2.5-2.5a.132.132,0,0,1,.023-.018l2.468-1.646a.15.15,0,0,1,.083-.025h4.419l.026,0,4.706.831a.151.151,0,0,1,.068.031Z",
    transform: "translate(148.402 36.684)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g428",
    transform: "translate(194.929 189.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path430",
    d: "M0-232.825l11.753-60.162,1.4-1.679,3.358,1.679L13.991-273.4,7.555-244.018,5.876-230.307Z",
    transform: "translate(0 294.666)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g432",
    transform: "translate(194.089 187.736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path434",
    d: "M-106.4-20.017l-14.831-5.317-1.959.839-3.638,22.386L-130.469,20l-4.2,19.308,1.679.56-.839-1.959L-129.63,20l3.638-21.826,3.638-20.987,1.4-1.4,3.638,1.959-1.119,8.675-3.358,17.909-5.876,26.863-1.119,7.275,23.225-9.234-.56-11.193,1.4-10.353.839-1.119L-107.8-5.466l.56-9.794Z",
    transform: "translate(134.666 25.333)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g436",
    transform: "translate(194.366 215.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path438",
    d: "M-274.668,0l-17.1,14.615A4.242,4.242,0,0,1-292.3,15l-18.524,11.441a3.177,3.177,0,0,1-.464.237l-3.7,1.524a2.174,2.174,0,0,1-1.634.008l-1.817-.727a1.045,1.045,0,0,1-.295-.18l-3.94-3.415a1.916,1.916,0,0,0-.266-.193l-1.258-.754h-1.5a1.72,1.72,0,0,0-.855.227l-1.561.892h-.863a2.446,2.446,0,0,0-1.468.489l-.467.35-.839.56-1.192-.17a.888.888,0,0,0-.98.635l-.223.779a1.072,1.072,0,0,0,.1.827l.573,1a1.591,1.591,0,0,0,.945.741l1.009.288a2.417,2.417,0,0,0,.666.093h1.619l-2.239,1.119-5.876,2.518-3.638,1.679-5.071,2.282a2,2,0,0,0-.845.716l-.332.5a2.315,2.315,0,0,0-.375,1.54l.1.874a1.959,1.959,0,0,0,.723,1.313l.024.019a2.069,2.069,0,0,0,1.675.418l3.544-.664,3.078-.839.28.56-3.078,1.4a2.308,2.308,0,0,0-.644,2.011l.135.813a2.124,2.124,0,0,0,1.58,1.711l.888.222,2.518-.839h.839l-.839,1.4-.053.161a3.4,3.4,0,0,0,.342,2.875l.121.193a1.465,1.465,0,0,0,1.242.688h1.707l1.679-1.119h.839l-.28.839-.468.468a1.4,1.4,0,0,0-.309,1.506,1.416,1.416,0,0,0,.756.775l.747.32a2.271,2.271,0,0,0,1.388.13l1.8-.4,7.835-3.638,3.918-1.679,3.638-3.078,2.287-1.83a4.106,4.106,0,0,1,1.124-.639l.656-.246a15.287,15.287,0,0,0,1.882-.855l2.725-1.467,8.395-3.638,11.473-4.2,9.8-3.609a16.151,16.151,0,0,0,1.635-.707l8.648-4.324a13.616,13.616,0,0,0,1.219-.69L-257.1,21.1a9.588,9.588,0,0,1,1.287-.687l5.926-2.607a6.736,6.736,0,0,1,.819-.3l3.461-1.018a1.832,1.832,0,0,0,1.2-1.115,5.924,5.924,0,0,0,.327-2.846l-.076-.585a45.92,45.92,0,0,0-1.971-8.585l-5.037,1.959-5.6.839-5.876-1.119-5.6-1.4-3.918-1.4Z",
    transform: "translate(347.623)",
    fill: "#eab5a8"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentimg);
export default __webpack_public_path__ + "static/media/Studentimg.792ef537a0edef60e89a5c6b8c9d9540.svg";
export { ForwardRef as ReactComponent };